module.exports = __webpack_public_path__ + "static/media/circle-success.5badbdf8.svg";